import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { BottomDrawerManageService } from '../bottom-drawer/bottom-drawer-manage.service';
import { ReportContentService } from '@services/ReportContentService/report-content.service';
import { catchError } from 'rxjs';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-report-content-modal',
  templateUrl: './report-content-modal.component.html',
  styleUrls: ['./report-content-modal.component.scss'],
})
export class ReportContentModalComponent  implements OnInit {

  @Input() label?: string;
  @Input() postId: number;
  @Input() replyId?: number;

  public showModal: EventEmitter<boolean> = new EventEmitter(false);
  public showReceivedNotify: EventEmitter<boolean> = new EventEmitter(false);
  public reportFGroup: FormGroup;

  public reasonsList: string[] = [
    'Bullying',
    'Harassment',
    'Inappropriate Language',
    'Self-harm Indication',
    'Sexual Content',
    'Other',
  ]

  get title(): string {
    return this.label ? `Report ${this.label}` : 'Report';
  }

  constructor(
    private fb: FormBuilder,
    private bottomDrawer: BottomDrawerManageService,
    private toast: ToastrService,
    private reportService: ReportContentService,
  ) { }

  ngOnInit() {
    this.initForm();
  }

  public onOpen() {
    this.showModal.next(true);
  }

  public onSubmit() {
    if (!this.reportFGroup.valid) return;

    this.reportService.sendReport(
      this.reportFGroup.controls['reason'].value,
      this.reportFGroup.controls['details'].value,
      this.postId,
      this.replyId,
    ).pipe(
      catchError((error: Error) => {
        this.toast.error(error.message, 'There was an error sending report.');
        return undefined;
      }),
    ).subscribe(() => {
      this.showModal.next(false);
      this.showReceivedNotify.next(true);
      this.bottomDrawer.closeAllDrawers();
    })
  }

  public onOk() {
    this.showReceivedNotify.next(false);
  }

  private initForm() {
    this.reportFGroup = this.fb.group({
      reason: ['', Validators.required],
      details: [''],
    })
  }
}
